import{CREATE_MODAL,REMOVE_MODAL}from"../../constants/ActionTypes";/**
 * Creates the dispatched CREATE_MODAL action object.
 * @param {Object} options The modal options.
 * @return {Object} The dispatched action object.
 */export var createModal=function createModal(options){return{type:CREATE_MODAL,options:options};};/**
 * Creates the dispatched REMOVE_MODAL action object.
 * @param {string} id The modal id to remove.
 * @return {Object} The dispatched action object.
 */export var removeModal=function removeModal(id){return{type:REMOVE_MODAL,id:id};};